
export default {
  'index.hero.title': 'Bienvenido a Pink Paradise',
  'index.hero.subtitle': 'La plataforma premium que conecta a individuos sofisticados con acompañantes de élite y contenido exclusivo, todo en un espacio seguro.',
  'index.hero.join_now': 'Únete ahora',
  'index.hero.explore': 'Explorar',
  'index.features.title': 'La Experiencia Premium Definitiva',
  'index.features.subtitle': 'Pink Paradise ofrece una combinación única de encuentros reales y contenido exclusivo',
  'index.features.privacy.title': 'Privacidad y Seguridad',
  'index.features.privacy.description': 'Medidas de seguridad líderes en la industria, incluidas opciones de acceso anónimo y discreción completa.',
  'index.features.content.title': 'Contenido Exclusivo',
  'index.features.content.description': 'Accede a fotos premium, vídeos y contenido personalizado disponible solo para suscriptores.',
  'index.features.messaging.title': 'Mensajería Segura',
  'index.features.messaging.description': 'Comunicación privada y encriptada entre clientes y escorts para concertar encuentros.',
  'index.subscription.title': 'Elige Tu Experiencia',
  'index.subscription.subtitle': 'Selecciona el nivel de membresía perfecto para satisfacer tus deseos',
  'index.subscription.basic.title': 'Pink Teaser',
  'index.subscription.basic.price': '€4.99',
  'index.subscription.basic.period': '/mes',
  'index.subscription.basic.feature1': 'Sin publicidad',
  'index.subscription.basic.feature2': 'Acceso a contenido privado teaser',
  'index.subscription.basic.feature3': 'Acceso básico a mensajería',
  'index.subscription.basic.cta': 'Comenzar',
  'index.subscription.regular.title': 'Pink Regular',
  'index.subscription.regular.price': '€19.99',
  'index.subscription.regular.period': '/mes',
  'index.subscription.regular.feature1': 'Verificación de cliente incluida',
  'index.subscription.regular.feature2': 'Acceso completo a todas las fotos y vídeos',
  'index.subscription.regular.feature3': 'Deja reseñas después de los encuentros',
  'index.subscription.regular.cta': 'Suscríbete Ahora',
  'index.subscription.vip.title': 'Pink VIP',
  'index.subscription.vip.price': '€99.99',
  'index.subscription.vip.period': '/mes',
  'index.subscription.vip.feature1': 'Insignia VIP en perfil y mensajes',
  'index.subscription.vip.feature2': 'Acceso anticipado a nuevas escorts',
  'index.subscription.vip.feature3': 'Acceso a escorts exclusivas para VIP',
  'index.subscription.vip.cta': 'Hazte VIP',
  'index.subscription.more_info': 'Ver información detallada de suscripción',
  'index.cta.title': '¿Listo para experimentar Pink Paradise?',
  'index.cta.subtitle': 'Únete a nuestra comunidad exclusiva hoy y descubre un mundo de conexiones y contenido premium.',
  'index.cta.create_account': 'Crear Cuenta',
  'index.cta.explore_profiles': 'Explorar Perfiles',
};
